export const UPDATE = 1;
export const SAVE = 2;
export const ORIGEN_ACREDITADO = 5;
export const A_VERIFICAR = 1;
export const VERIFICADO = 2;
export const RECHAZADO = 3;
